import { gql, TypedDocumentNode } from "@apollo/client";

import {
  AcceptLlmCustomizationMutation,
  AcceptLlmCustomizationMutationVariables,
} from "./AcceptLlmCustomization.generated";

const ACCEPT_LLM_CUSTOMIZATIONS: TypedDocumentNode<
  AcceptLlmCustomizationMutation,
  AcceptLlmCustomizationMutationVariables
> = gql`
  mutation AcceptLlmCustomization(
    $AcceptLLMCustomizationsInput: AcceptLLMCustomizationsInput!
  ) {
    acceptLlmCustomization(
      acceptLlmCustomizationInput: $AcceptLLMCustomizationsInput
    ) {
      ok
    }
  }
`;

export default ACCEPT_LLM_CUSTOMIZATIONS;
